import React, { useState, useEffect } from 'react';
import { supabase } from '../../services/supabase';
import './Admin.css';

const ManageSermon = () => {
    const [currentUrl, setCurrentUrl] = useState('');
    const [newUrl, setNewUrl] = useState('');
    const [loading, setLoading] = useState(true);
    const [saving, setSaving] = useState(false);
    const [message, setMessage] = useState('');

    useEffect(() => {
        fetchLatestSermon();
    }, []);

    const fetchLatestSermon = async () => {
        setLoading(true);
        try {
            const { data, error } = await supabase
                .from('sermons')
                .select('youtube_url')
                .order('created_at', { ascending: false })
                .limit(1);

            if (error) {
                console.error("Error fetching sermon:", error);
                setMessage('Error loading current sermon.');
            } else if (data && data.length > 0) {
                setCurrentUrl(data[0].youtube_url);
            }
        } catch (error) {
            console.error("Error:", error);
        } finally {
            setLoading(false);
        }
    };

    const handleSave = async (e) => {
        e.preventDefault();
        
        if (!newUrl) {
            setMessage('Please enter a valid YouTube URL.');
            return;
        }

        setSaving(true);
        setMessage('');

        try {
            const { error } = await supabase
                .from('sermons')
                .insert([{ youtube_url: newUrl }]);

            if (error) {
                console.error("Error saving sermon:", error);
                setMessage('Failed to update the sermon.');
            } else {
                setMessage('Sermon successfully updated!');
                setCurrentUrl(newUrl);
                setNewUrl('');
            }
        } catch (error) {
            console.error("Error:", error);
            setMessage('An unexpected error occurred.');
        } finally {
            setSaving(false);
        }
    };

    return (
        <div className="admin-dashboard">
            <h2>Manage Latest Sermon</h2>
            <div className="admin-card">
                <h3>Current Featured Sermon</h3>
                {loading ? (
                    <p>Loading...</p>
                ) : currentUrl ? (
                    <div className="current-sermon">
                        <p><a href={currentUrl} target="_blank" rel="noopener noreferrer">{currentUrl}</a></p>
                    </div>
                ) : (
                    <p>No sermon currently featured.</p>
                )}
            </div>

            <div className="admin-card">
                <h3>Update Sermon</h3>
                <p>Paste the full YouTube URL (e.g., https://www.youtube.com/watch?v=WQx0IUsX1ik) of the latest sermon.</p>
                <form onSubmit={handleSave} className="admin-form">
                    <div className="form-group">
                        <label>YouTube URL</label>
                        <input
                            type="url"
                            value={newUrl}
                            onChange={(e) => setNewUrl(e.target.value)}
                            placeholder="https://youtu.be/..."
                            required
                        />
                    </div>
                    <button type="submit" disabled={saving} className="btn btn-primary">
                        {saving ? 'Updating...' : 'Set as Latest Sermon'}
                    </button>
                    {message && <p className={`admin-message ${message.includes('success') ? 'success' : 'error'}`}>{message}</p>}
                </form>
            </div>
        </div>
    );
};

export default ManageSermon;
